import './ActPriceList.scss';
const currencyFormatter = new Intl.NumberFormat('hu-HU', {
  style: 'currency',
  currency: 'HUF',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const ActPriceList = ({ data }) => {
  return (
    <div>
      <p>
        {data.tantargy_descr} - {currencyFormatter.format(data.dij)}
      </p>
    </div>
  );
};
